var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSharepointIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1333.34 1333.34",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".fil4{fill:#000;fill-rule:nonzero;fill-opacity:.2}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2630364347808"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 395.83,
    r: 395.84,
    fill: "#036c70",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 994.79,
    cy: 744.79,
    r: 338.54,
    fill: "#1a9ba1",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.67,
    cy: 1062.5,
    r: 270.83,
    fill: "#37c6d0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.46 291.67H243.04a396.731 396.731 0 00-13.87 103.92c0 218.62 177.22 395.99 395.84 396.08 11.54 0 22.96-.54 34.29-1.5l.21 1.58c-146.72 3.87-263.68 123.96-263.68 270.74 0 7.01.26 13.96.8 20.85h297.83c30.63-.09 55.46-24.91 55.54-55.55V347.21c-.09-30.63-24.91-55.46-55.55-55.54z",
    fillRule: "nonzero",
    fillOpacity: 0.102
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M652.79 333.33H234.04c-3.24 20.57-4.93 41.45-4.93 62.3 0 218.64 177.26 395.99 395.9 396.04 11.54 0 22.96-.54 34.29-1.5l.21 1.58c-146.78 3.97-263.69 124.12-263.69 270.95 0 20.98 2.45 41.89 7.25 62.31h249.72c30.63-.09 55.45-24.91 55.54-55.54V388.89c-.09-30.63-24.91-55.45-55.55-55.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M652.79 333.33H234.04c-3.24 20.57-4.93 41.45-4.93 62.3 0 218.64 177.26 395.99 395.9 396.04 11.54 0 22.96-.54 34.29-1.5l.21 1.58c-138.68 3.65-252.29 111.6-262.93 249.91l256.22.01c30.63-.09 55.45-24.91 55.54-55.54V388.88c-.09-30.63-24.91-55.45-55.55-55.54z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil4",
    d: "M611.13 333.33H234.04c-3.24 20.57-4.93 41.45-4.93 62.3 0 218.64 177.26 395.99 395.9 396.04 11.54 0 22.96-.54 34.29-1.5l.21 1.58c-138.68 3.65-252.29 111.6-262.93 249.91l214.55.01c30.63-.09 55.45-24.91 55.54-55.54V388.88c-.09-30.63-24.91-55.45-55.54-55.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.54 333.33h555.59c30.67 0 55.54 24.87 55.54 55.54v555.58c0 30.67-24.87 55.54-55.54 55.54H55.54C24.87 999.99 0 975.12 0 944.45V388.87c0-30.67 24.87-55.54 55.54-55.54z",
    fill: "#03787c",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25 659.38A110.186 110.186 0 01202 623.12a98.306 98.306 0 01-11.99-47.06c0-.83.02-1.69.04-2.51-.02-.97-.05-1.98-.05-2.96 0-22.39 7.89-44.09 22.25-61.25 15.76-17.96 36.22-31.3 59.01-38.5 25.12-8.29 51.5-12.52 77.98-12.52h2.65c3.7-.08 7.51-.19 11.25-.19 32.21 0 64.34 5.13 94.95 15.07v75c-14.86-9-31.1-15.65-48.04-19.63a234.22 234.22 0 00-55.7-6.74h-.51a121.89 121.89 0 00-57.76 12.22c-13.84 5.97-22.83 19.61-22.87 34.7v.32c0 9.03 3.48 17.73 9.71 24.26A88.548 88.548 0 00309.04 612c10.95 5.44 27.28 12.67 49 21.67 2.41.76 4.77 1.7 7.04 2.79a404.138 404.138 0 0161.82 30.5 110.62 110.62 0 0136.52 36.78c8.7 15.78 13.28 33.51 13.28 51.53 0 1.31-.04 2.67-.07 3.97a103.37 103.37 0 01-20.79 66.88c-14.48 17.63-33.83 30.63-55.62 37.33a251.94 251.94 0 01-75.49 11.57c-1.23 0-2.56-.03-3.75-.03-.5.01-1.17.01-1.67.01-23.47 0-46.98-1.99-70.09-5.92-20.03-3.15-39.7-8.87-58.34-16.84v-79.25c17.87 12.74 37.86 22.29 59.01 28.12 21 6.57 42.93 10.08 64.92 10.42 2.35.15 4.74.23 7.1.23 18.02 0 35.82-4.38 51.78-12.72a39.498 39.498 0 0019.8-34.22c0-.36 0-.72-.02-1.07v-.31c0-10.01-3.99-19.62-11.08-26.69a112.794 112.794 0 00-30.63-21.34c-13.03-6.56-32.28-15.17-57.75-25.83-20.17-8.07-39.6-18.3-57.76-30.22v.01z",
    fill: "#fff",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "nonzero",
    d: "M0 0h1333.34v1333.34H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharepointIcon);
export default __webpack_public_path__ + "static/media/sharepoint-icon.beb218d56ff95bfc323e0ce2d80240ad.svg";
export { ForwardRef as ReactComponent };